import { API_BASE } from '../constants/config';

function cacheSuffix(cacheBust, urlHasQuery) {
  if (cacheBust == null) {
    return '';
  }
  return `${urlHasQuery ? '&' : '?'}cb=${cacheBust}`;
}

/**
 * Portrait URLs to try in order (bulk upload saves under routes/Uploads).
 */
export function farmerPhotoUrls(farmer, cacheBust) {
  const raw = farmer?.image;
  if (raw == null || raw === '') {
    const mongoId = farmer?._id;
    if (!mongoId) {
      return [];
    }
    const fallback = `${mongoId}.jpg`;
    const suffix = cacheSuffix(cacheBust, false);
    return [
      `${API_BASE}/routes/Uploads/${fallback}${suffix}`,
      `${API_BASE}/routes/uploads/${fallback}${suffix}`,
    ];
  }

  const filename = String(raw).trim().replace(/^\/+/, '');
  if (/^https?:\/\//i.test(filename)) {
    return [`${filename}${cacheSuffix(cacheBust, filename.includes('?'))}`];
  }

  const suffix = cacheSuffix(cacheBust, false);
  return [
    `${API_BASE}/routes/Uploads/${filename}${suffix}`,
    `${API_BASE}/routes/uploads/${filename}${suffix}`,
    `${API_BASE}/router/uploads/${filename}${suffix}`,
  ];
}

export function farmerPhotoUrl(farmer, cacheBust) {
  const urls = farmerPhotoUrls(farmer, cacheBust);
  return urls[0] ?? null;
}

export function farmerInitials(farmer) {
  const name = String(farmer?.farmername ?? farmer?.name ?? '?').trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
}
